/**
 * Generated by orval 🍺
 * Do not edit manually.
 * OnEarly Core API
 * OnEarly Core HTTP API
 * OpenAPI spec version: 0.0.1
 */
import * as zod from 'zod';

export const SearchActor = zod.object({
  actorUuid: zod.uuid().describe('UUID v4 identifier'),
  match: zod.enum(['SELF', 'IN_SCOPE', 'ANY']),
});

export type SearchActor = zod.input<typeof SearchActor>;
export type SearchActorOutput = zod.output<typeof SearchActor>;
